const { objectOperator } = require('../agent/utils/spread');
const commons = require('./commons');
const {
  AVAILABILITY_FAILURE,
  AVAILABILITY_TRANSFER_SIZE,
  AVAILABILITY_BROWSER_ERRORS,
} = require('./metrics');

const metrics = [AVAILABILITY_FAILURE, AVAILABILITY_TRANSFER_SIZE, AVAILABILITY_BROWSER_ERRORS];

// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const fileSupport = {
  img: ['apng', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'],
  script: ['js'],
  style: ['css'],
};

// Expressed to octets/bytes
const thresholdEntries = {
  img: 250000,
  script: 170000,
  style: 50000,
};

module.exports = objectOperator([commons, { thresholdEntries, fileSupport, metrics }]);

